module.exports = __webpack_public_path__ + "img/icon-dy.e5c6d672.png";